import "./loginStyle.css";
import React from "react";
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage } from '@toolpad/core/SignInPage';
import { useTheme } from '@mui/material/styles';

const providers = [
    { id: 'google', name: 'Google' },
    { id: 'facebook', name: 'Facebook' },
];

const signIn = async (provider) => {
    const promise = new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, 500);
    });
    return promise;
};


const LoginOAuth = () => {
    const theme = useTheme();

    return (
        <>
            <AppProvider theme={theme}>
                <SignInPage signIn={signIn} providers={providers} sx={{ minHeight: '25vh' }} slots={{
                    title: () => (
                       ""
                    ),
                    subtitle: () => (
                       ""
                    ),
                }}/>
            </AppProvider>
        </>
    );
};

export default LoginOAuth;
